import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/image/banner.jpg'
import _imports_1 from '../assets/image/product-img.png'
import _imports_2 from '../assets/image/advantages-img1.png'
import _imports_3 from '../assets/image/advantages-img2.png'
import _imports_4 from '../assets/image/advantages-img3.png'
import _imports_5 from '../assets/image/advantages-img4.png'
import _imports_6 from '../assets/image/advantages-img5.png'
import _imports_7 from '../assets/image/advantages-img6.png'
import _imports_8 from '../assets/image/advantages-img7.png'
import _imports_9 from '../assets/image/scenaros-img1.jpg'
import _imports_10 from '../assets/image/scenaros-img2.jpg'
import _imports_11 from '../assets/image/scenaros-img3.jpg'
import _imports_12 from '../assets/image/scenaros-img4.jpg'
import _imports_13 from '../assets/image/scenaros-img5.jpg'
import _imports_14 from '../assets/image/scenaros-img6.jpg'
import _imports_15 from '../assets/image/prospec-img1.png'
import _imports_16 from '../assets/image/prospec-img2.png'
import _imports_17 from '../assets/image/prospec-img3.png'
import _imports_18 from '../assets/image/prospec-img4.png'
import _imports_19 from '../assets/image/prospec-img5.png'
import _imports_20 from '../assets/image/prospec-img6.png'
import _imports_21 from '../assets/image/policy-img1.png'
import _imports_22 from '../assets/image/policy-img2.png'
import _imports_23 from '../assets/image/policy-img3.png'
import _imports_24 from '../assets/image/footer-img.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "banner",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "selection about" }
const _hoisted_4 = { class: "selection-limit" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "关于辉映", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "secondary-title" }, "ABOUT HUIYING", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "about-contet about-content-text" }, " 杭州辉映智能科技有限公司成立于2017年 ，是一家专注于智能影棚方案设计 、AI 拍摄软硬件系统一体化研发生产供应商 ，致力于为旅游景区提供综合性的数字媒体解 决方案 。核心团队涵盖了大数据智能算法、影视后期等高级人才 。由于项目的创新性 公司先后获得专业机构种子轮天使轮的投资。 ", -1)
const _hoisted_8 = { class: "about-card-row" }
const _hoisted_9 = {
  class: "right-line about-cart-col",
  style: {"text-align":"center"}
}
const _hoisted_10 = { class: "about-card-number about-card-number1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "about-card-text" }, "公司成立", -1)
const _hoisted_12 = {
  class: "right-line about-cart-col",
  style: {"text-align":"center"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "about-card-text" }, "注册资金", -1)
const _hoisted_14 = {
  xs: 24,
  sm: 8,
  md: 8,
  lg: 8,
  xl: 8,
  class: "about-cart-col",
  style: {"text-align":"center"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "about-card-text" }, "专利认证", -1)
const _hoisted_16 = { class: "selection selection-bg selection-productImg" }
const _hoisted_17 = { class: "selection-limit" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", null, "产品展示", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "secondary-title" }, "PRODUCT DISPLAY", -1)
const _hoisted_20 = {
  class: "product-img",
  ref: "productImg",
  src: _imports_1,
  alt: "影棚模型图"
}
const _hoisted_21 = { class: "selection" }
const _hoisted_22 = { class: "selection-limit" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h1", null, "品牌故事", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", { class: "secondary-title" }, "BRAND STORY", -1)
const _hoisted_25 = { class: "selection selection-bg" }
const _hoisted_26 = { class: "selection-limit" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h1", null, "产品优势", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", { class: "secondary-title" }, "PRODUCT ADVANTAGES", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "advantages-img",
    src: _imports_2
  })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-center" }, "AI科创项目", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "0人工 0成本 0库存")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "advantages-img",
    src: _imports_3
  })
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-center" }, "海量内容", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "海量原创艺术场景"),
  /*#__PURE__*/_createElementVNode("span", null, "照片+短视频")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "advantages-img",
    src: _imports_4
  })
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-center" }, "专业团队", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "核心团队涵盖了"),
  /*#__PURE__*/_createElementVNode("span", null, "大数据智能算法"),
  /*#__PURE__*/_createElementVNode("span", null, "影视后期等高级人才")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "advantages-img",
    src: _imports_5
  })
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-center" }, "专利技术", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "AI设计师"),
  /*#__PURE__*/_createElementVNode("span", null, "国内领先"),
  /*#__PURE__*/_createElementVNode("span", null, "15项专利技术")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "advantages-img",
    src: _imports_6
  })
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-center" }, "智能运营", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "人机互动 即拍即得")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "advantages-img",
    src: _imports_7
  })
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-center" }, "品牌效应", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "规模运作 品牌效应")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "advantages-img",
    src: _imports_8
  })
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-center" }, "品牌效应", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "advantages-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "沉浸式场景穿越体验"),
  /*#__PURE__*/_createElementVNode("span", null, "亲民、大众消费")
], -1)
const _hoisted_50 = { class: "selection" }
const _hoisted_51 = { class: "selection-limit" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h1", null, "投放场景", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h3", { class: "secondary-title" }, "LAUNCH SCENARIOS", -1)
const _hoisted_54 = { class: "scenaros-card" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_9 })
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-title" }, "全国景区"),
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-content" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "停车场、售票处"),
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "游客休息区")
  ])
], -1)
const _hoisted_57 = { class: "scenaros-card" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_10 })
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-title" }, "娱乐服务"),
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-content" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "KTV、游乐场、洗浴中心"),
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "美容店等")
  ])
], -1)
const _hoisted_60 = { class: "scenaros-card" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_11 })
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-title" }, "学校"),
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-content" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "食堂、超市、体育馆"),
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "等")
  ])
], -1)
const _hoisted_63 = { class: "scenaros-card" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_12 })
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-title" }, "交通场所"),
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-content" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "火车站、高铁站"),
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "机场等")
  ])
], -1)
const _hoisted_66 = { class: "scenaros-card" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_13 })
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-title" }, "电影院"),
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-content" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "售票厅、等候区"),
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "等")
  ])
], -1)
const _hoisted_69 = { class: "scenaros-card" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_14 })
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-title" }, "大型商场"),
  /*#__PURE__*/_createElementVNode("div", { class: "scenaros-bottom-content" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "服装店、餐厅"),
    /*#__PURE__*/_createElementVNode("p", { class: "scenaros-bottom-text" }, "茶饮店、超市等")
  ])
], -1)
const _hoisted_72 = { class: "selection selection-bg" }
const _hoisted_73 = { class: "selection-limit" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h1", null, "市场前景", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h3", { class: "secondary-title" }, "PROSPECT", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "prospect-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_15,
      class: "prospec-img"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-content" }, "AI智能拍摄")
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "prospect-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_16,
      class: "prospec-img"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-content" }, "年轻人市场")
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "prospect-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_17,
      class: "prospec-img"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-content" }, "影视/CG级场景服务")
], -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "prospect-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_18,
      class: "prospec-img"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-content" }, "全智能化运营")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "prospect-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_19,
      class: "prospec-img"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-content" }, "物美价廉")
], -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "prospect-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_20,
      class: "prospec-img"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "prospect-content" }, "加盟商优选")
], -1)
const _hoisted_82 = { class: "selection" }
const _hoisted_83 = { class: "selection-limit" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h1", null, "加盟优势", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h3", { class: "secondary-title" }, "FRANCHISE POLICY", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "policy-card" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_21,
    class: "policy-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "policy-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "policy-title" }, "加盟优势"),
    /*#__PURE__*/_createElementVNode("div", { class: "policy-text" }, [
      /*#__PURE__*/_createElementVNode("p", null, "零人工"),
      /*#__PURE__*/_createElementVNode("p", null, "零库存"),
      /*#__PURE__*/_createElementVNode("p", null, "零管理"),
      /*#__PURE__*/_createElementVNode("p", null, "零技术门槛")
    ])
  ])
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "policy-card" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_22,
    class: "policy-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "policy-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "policy-title" }, "加盟流程"),
    /*#__PURE__*/_createElementVNode("div", { class: "policy-text" }, [
      /*#__PURE__*/_createElementVNode("p", null, "联系我们   获得资料"),
      /*#__PURE__*/_createElementVNode("p", null, "了解项目   确定合作"),
      /*#__PURE__*/_createElementVNode("p", null, "选择地址   安装指导"),
      /*#__PURE__*/_createElementVNode("p", null, "查看收益      ")
    ])
  ])
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "policy-card" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_23,
    class: "policy-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "policy-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "policy-title" }, "支持服务"),
    /*#__PURE__*/_createElementVNode("div", { class: "policy-text" }, [
      /*#__PURE__*/_createElementVNode("p", null, "选址、安装服务"),
      /*#__PURE__*/_createElementVNode("p", null, "提供海量原创内容"),
      /*#__PURE__*/_createElementVNode("p", null, "支持日常运维服务"),
      /*#__PURE__*/_createElementVNode("p", null, "支持线上系统服务")
    ])
  ])
], -1)
const _hoisted_89 = { class: "footer" }
const _hoisted_90 = { class: "selection-limit" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "contact-us" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contact-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "contact-title-first" }, "联"),
    /*#__PURE__*/_createTextVNode("系我们")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contact-content-box" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "contact-content" }, [
      /*#__PURE__*/_createElementVNode("span", null, "公司电话："),
      /*#__PURE__*/_createElementVNode("span", null, "17706712132")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "contact-content" }, [
      /*#__PURE__*/_createElementVNode("span", null, "招商热线："),
      /*#__PURE__*/_createElementVNode("span", null, "19106850610")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "contact-content" }, [
      /*#__PURE__*/_createElementVNode("span", null, "公司地址："),
      /*#__PURE__*/_createElementVNode("span", null, "浙江省杭州市拱墅区要将国际大厦A座18A")
    ])
  ])
], -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("img", {
  class: "footer-img",
  src: _imports_24
}, null, -1)
const _hoisted_93 = { class: "divider-box" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "footer-bottom" }, [
  /*#__PURE__*/_createTextVNode("杭州辉映智能科技有限公司 © 2020-2023 "),
  /*#__PURE__*/_createElementVNode("span", { class: "footer-right" }, "浙ICP备2020031794号")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_cord = _resolveComponent("el-cord")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_el_row, {
            gutter: 24,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 14,
                md: 14,
                lg: 14,
                xl: 14
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _createElementVNode("b", _hoisted_10, _toDisplayString(Math.round($setup.num1Output)), 1)
                      ]),
                      _hoisted_11
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("b", {
                          class: "about-card-number about-card-number2",
                          ref: "aboutCardNumber2"
                        }, _toDisplayString(Math.round($setup.num2Output)), 513)
                      ]),
                      _hoisted_13
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", null, [
                        _createElementVNode("b", {
                          class: "about-card-number about-card-number3",
                          ref: "aboutCardNumber3"
                        }, _toDisplayString(Math.round($setup.num3Output)), 513)
                      ]),
                      _hoisted_15
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "about-img",
                    src: require('@/assets/image/about-img.png')
                  }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("div", null, [
            _createElementVNode("img", _hoisted_20, null, 512)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _hoisted_24,
          _createVNode(_component_el_row, {
            gutter: 24,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, {
                    gutter: 18,
                    class: "brand-content"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 当代社会，人们渴望在快节奏的生活中找到一种富有创意和趣味的方式来放松自己，智拍鸭AI智能自拍馆应运而生。通过智能技术和虚拟场景，让用户探索神秘的世界，自由拍摄出充满艺术感和个性的照片和视频，成为了现代收获生活趣味的一部分。这里是一个融合了时尚和科技的拍摄空间，让你在轻松愉悦的氛围中释放你的创意和个性，留下独一无二的美好回忆。 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, {
                    gutter: 24,
                    justify: "center",
                    ref: "brandLeft"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.srcList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          xs: 24,
                          sm: 9,
                          md: 9,
                          lg: 8,
                          xl: 8,
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_image, {
                              class: "brand-img",
                              fit: "contain",
                              "zoom-rate": 1.2,
                              src: item,
                              "preview-src-list": $setup.srcList,
                              "initial-index": index
                            }, null, 8, ["zoom-rate", "src", "preview-src-list", "initial-index"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _hoisted_28,
          _createVNode(_component_el_row, {
            gutter: 21,
            justify: "space-around"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 10,
                sm: 7,
                md: 7,
                lg: 3,
                xl: 3,
                class: "advantages-card"
              }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 10,
                sm: 7,
                md: 7,
                lg: 3,
                xl: 3,
                class: "advantages-card"
              }, {
                default: _withCtx(() => [
                  _hoisted_32,
                  _hoisted_33,
                  _hoisted_34
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 10,
                sm: 7,
                md: 7,
                lg: 3,
                xl: 3,
                class: "advantages-card"
              }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  _hoisted_36,
                  _hoisted_37
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 10,
                sm: 7,
                md: 7,
                lg: 3,
                xl: 3,
                class: "advantages-card"
              }, {
                default: _withCtx(() => [
                  _hoisted_38,
                  _hoisted_39,
                  _hoisted_40
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 10,
                sm: 7,
                md: 7,
                lg: 3,
                xl: 3,
                class: "advantages-card"
              }, {
                default: _withCtx(() => [
                  _hoisted_41,
                  _hoisted_42,
                  _hoisted_43
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 10,
                sm: 7,
                md: 7,
                lg: 3,
                xl: 3,
                class: "advantages-card"
              }, {
                default: _withCtx(() => [
                  _hoisted_44,
                  _hoisted_45,
                  _hoisted_46
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 10,
                sm: 7,
                md: 7,
                lg: 3,
                xl: 3,
                class: "advantages-card"
              }, {
                default: _withCtx(() => [
                  _hoisted_47,
                  _hoisted_48,
                  _hoisted_49
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _hoisted_53,
          _createVNode(_component_el_row, {
            gutter: 22,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                md: 8,
                lg: 4,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_el_cord, { class: "scenaros-box" }, {
                      default: _withCtx(() => [
                        _hoisted_55,
                        _hoisted_56
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                md: 8,
                lg: 4,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_el_cord, { class: "scenaros-box" }, {
                      default: _withCtx(() => [
                        _hoisted_58,
                        _hoisted_59
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                md: 8,
                lg: 4,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_component_el_cord, { class: "scenaros-box" }, {
                      default: _withCtx(() => [
                        _hoisted_61,
                        _hoisted_62
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                md: 8,
                lg: 4,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_el_cord, { class: "scenaros-box" }, {
                      default: _withCtx(() => [
                        _hoisted_64,
                        _hoisted_65
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                md: 8,
                lg: 4,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_el_cord, { class: "scenaros-box" }, {
                      default: _withCtx(() => [
                        _hoisted_67,
                        _hoisted_68
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                md: 8,
                lg: 4,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_el_cord, { class: "scenaros-box" }, {
                      default: _withCtx(() => [
                        _hoisted_70,
                        _hoisted_71
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("div", _hoisted_73, [
          _hoisted_74,
          _hoisted_75,
          _createVNode(_component_el_row, {
            gutter: 24,
            justify: "space-around"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_76
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_77
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_78
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_79
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_80
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_81
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _hoisted_84,
          _hoisted_85,
          _createVNode(_component_el_row, {
            gutter: 24,
            justify: "space-around"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8,
                class: "policy-col"
              }, {
                default: _withCtx(() => [
                  _hoisted_86
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8,
                class: "policy-col"
              }, {
                default: _withCtx(() => [
                  _hoisted_87
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 8,
                xl: 8,
                class: "policy-col"
              }, {
                default: _withCtx(() => [
                  _hoisted_88
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("footer", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, [
          _createVNode(_component_el_row, {
            gutter: 24,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_91
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 6,
                md: 6,
                lg: 6,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _hoisted_92
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_93, [
            _createVNode(_component_el_divider, { "border-style": { color: '#fff' } })
          ]),
          _hoisted_94
        ])
      ])
    ])
  ]))
}